import { BACKEND_URL_PREFIX } from "../utils/const";
import { buildDefaultHeaders } from "./helper";
import { checkAndUpdateToken } from "./auth";
import {
  COURSE_FETCH_COMPLETED,
  NETWORK_REQUEST_SENT,
  PERFORMANCE_FETCH_COMPLETED,
  PERFORMANCE_FETCH_STARTED,
  PERFORMANCE_LIST_FETCH_COMPLETED,
  PERFORMANCE_LIST_FETCH_STARTED,
  TERMS_FETCH_COMPLETED,
  MARK_LIST
} from "./types";

// TODO Задиспатчить семестры из list

export const list = (yearId, type) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: PERFORMANCE_LIST_FETCH_STARTED });
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/${type ? "progress_total" : "progress"}/${
        getState().auth.mid
      }/${yearId}`,
      buildDefaultHeaders(getState)
    );
    dispatch({ type: NETWORK_REQUEST_SENT, response });
    if (response.ok) {
      const result = await response.json();
      dispatch({ type: PERFORMANCE_LIST_FETCH_COMPLETED, payload: result });
    }
  }
};

export const performance = (semesterId, courseId) => async (
  dispatch,
  getState
) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: PERFORMANCE_FETCH_STARTED });
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/progress_detail/${
        getState().auth.mid
      }/${semesterId}/${courseId}`,
      buildDefaultHeaders(getState)
    );
    dispatch({ type: NETWORK_REQUEST_SENT, response });
    if (response.ok) {
      const result = await response.json();
      dispatch({
        type: PERFORMANCE_FETCH_COMPLETED,
        progressDetail: result.progressDetail,
      });
    }
  }
};

export const terms = (yearId) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/year/term/${yearId}`,
      buildDefaultHeaders(getState)
    );
    dispatch({ type: NETWORK_REQUEST_SENT, response });
    if (response.ok) {
      const result = await response.json();
      dispatch({ type: TERMS_FETCH_COMPLETED, terms: result.terms });
    }
  }
};

export const course = (courseId) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/course/${courseId}`,
      buildDefaultHeaders(getState)
    );
    dispatch({ type: NETWORK_REQUEST_SENT, response });
    if (response.ok) {
      const result = await response.json();
       dispatch({ type: COURSE_FETCH_COMPLETED, course: result.course });
    }
  }
};

export const getMarksList = (userId = null, year = null, term = 0) =>
  
async (dispatch, getState) => {

    const response = await fetch(
      `${BACKEND_URL_PREFIX}/users/${userId}/rate_exam/${year}/${term}`,
      buildDefaultHeaders(getState)
    );


    if (response.ok) {
      const result = await response.json();

      dispatch({
        type: MARK_LIST,
        payload: [
          {
            name: "Рейтинг по группе",
            list: result[0].gid, 
          },
          {
            name: "Рейтинг по курсу",
            list: result[1].year,
          },
          {
            name: "Рейтинг по факультету",
            list: result[2].idfaculty,
          },
        ],
      });
    }
  };